<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters class="mb-4">
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="search"
            label="Search invoice item description"
            outlined
            dense
            hide-details
            clearable
            @keyup.enter.native="searchTable()"
            @click:clear="clearSearch()"
          ></v-text-field>
        </v-col>
        <v-col cols="auto" class="pl-2">
          <v-btn color="primary" @click="searchTable()">Search</v-btn>
        </v-col>
      </v-row>
      <v-skeleton-loader
        v-if="!initiated"
        ref="skeleton"
        type="table"
        class="mx-auto"
      ></v-skeleton-loader>
      <v-data-table
        v-if="initiated"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [30,60,100,150,250],
        }"
      >
        <template v-slot:item.line_items="{ item }">
          <div v-if="item.line_items">
            <div v-for="(line, i) in item.line_items.split('||')" :key="i">
              {{ line }}
            </div>
          </div>
        </template>
        <template v-slot:item.subtotal="{ item }">
          {{ parseFloat(item.subtotal).toFixed(2) }}
        </template>
        <template v-slot:item.tax="{ item }">
          {{ parseFloat(item.tax).toFixed(2) }}
        </template>
        <template v-slot:item.total="{ item }">
          {{ parseFloat(item.total).toFixed(2) }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TransactionList',
  data() {
    return {
      search: '',
      initiated: false,
      totalItems: 0,
      items: [],
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 30,
        sortBy: ['invoice_no'],
        sortDesc: [true],
      },
      headers: [
        { text: 'Invoice NO', value: 'invoice_no', sortable: true },
        { text: 'Invoice Date', value: 'invoice_datetime', sortable: true },
        { text: 'Line Items', value: 'line_items', sortable: false },
        { text: 'Subtotal', value: 'subtotal', sortable: true },
        { text: 'Tax', value: 'tax', sortable: false },
        { text: 'Total', value: 'total', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.initiated) {
          this.loadTable();
        }
      },
      deep: true,
    },
  },
  created() {
    this.initiated = true;
    this.loadTable();
  },
  methods: {
    searchTable() {
      this.options.page = 1;
      this.loadTable();
    },
    clearSearch() {
      this.search = '';
      this.searchTable();
    },
    loadTable() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;
      this.loading = true;
      this.$api.post('partner/transaction/list', {
        search: {
          '*': this.search,
        },
        current_page: page,
        per_page: itemsPerPage,
        order: `${sortBy}:${sortDesc}`,
      })
        .then((response) => {
          this.totalItems = response.data.total;
          this.items = response.data.data;
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>

</style>
